// AUTOID — EasySearch hydration helper.
//
// Injects a "Shop Parts" action into the EasySearch garage overlay of every
// main widget (desktop car panel, mobile drawer, homepage app block; each has
// its own "Shopping for" well, and a hidden one can come first in the page)
// once the app fires its `easysearch_loaded` event. Defensive logging + guarded
// selector lookups keep the failure point visible in DevTools (look for
// [autoid-easysearch] entries). The script does not change page behaviour
// when the selectors resolve; it only adds the injected control and
// gracefully no-ops when EasySearch hasn't initialised.
//
// Diagnostic checklist:
//   1. Open desktop mega menu (Car trigger) and watch the console.
//   2. Look for `[autoid-easysearch] easysearch_loaded fired` — if you
//      never see it, EasySearch's own app embed didn't init (check Network
//      tab for the EasySearch script load, and the app's enable toggle).
//   3. If the event fires but `widget` is null, the EasySearch app changed
//      its top-level class — update the .easysearch-main-widget selector.
//   4. If `widget` is found but garageContent / searchBtn are null, the
//      EasySearch app changed its internal class names — update the inner
//      selectors below.
(function () {
  var DEBUG_TAG = '[autoid-easysearch]';
  document.addEventListener('easysearch_loaded', function () {
    if (window.console && console.debug) console.debug(DEBUG_TAG + ' easysearch_loaded fired');
    var widgets = document.querySelectorAll('.easysearch-main-widget');
    if (!widgets.length) {
      if (window.console && console.debug) console.debug(DEBUG_TAG + ' .easysearch-main-widget not found — skipping Shop Parts injection');
      return;
    }
    Array.prototype.forEach.call(widgets, function (widget) {
      var easyGarageContent = widget.querySelector('.easysearch-garage-overlay-content');
      var easySearchBtn = widget.querySelector('.easysearch-btn.easysearch-btn-search');
      if (!easyGarageContent || !easySearchBtn) {
        if (window.console && console.debug) console.debug(DEBUG_TAG + ' overlay-content or search-btn selector did not match — selectors may have drifted', { hasGarageContent: !!easyGarageContent, hasSearchBtn: !!easySearchBtn });
        return;
      }
      if (easyGarageContent.querySelector('.easysearch-garage-overlay-custom-search')) return;
      var div = document.createElement('div');
      div.className = 'easysearch-garage-overlay-custom-search';
      div.innerHTML = '<a href="#" class="easysearch-btn">Shop Parts</a>';
      easyGarageContent.appendChild(div);
      div.addEventListener('click', function (event) {
        event.preventDefault();
        easySearchBtn.click();
      });
    });
  });
})();
